<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopSetting.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="shopSettingManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-select v-model="shopSettingManageInfo.conditions.settingType"
              :placeholder="$t('shopSetting.selectSettingType')" style="width:100%">
              <el-option v-for="(item, index) in shopSettingManageInfo.settingTypes" :key="index" :label="item.name"
                :value="item.statusCd"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="shopSettingManageInfo.conditions.settingName"
              :placeholder="$t('shopSetting.inputSettingName')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="shopSettingManageInfo.conditions.settingKey"
              :placeholder="$t('shopSetting.inputSettingKey')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryShopSettingMethod">
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
            <el-button type="primary" size="small" @click="_resetCommunitySettingMethod">
              <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopSetting.shopSettings') }}</div>
        <div class="flex justify-end">
          <el-button type="primary" size="small" @click="_openAddShopSettingModal">
            {{ $t('common.add') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="shopSettingManageInfo.shopSettings" style="width:100%" border>
          <el-table-column prop="settingTypeName" :label="$t('shopSetting.typeName')" align="center"></el-table-column>
          <el-table-column prop="settingName" :label="$t('shopSetting.settingName')" align="center"></el-table-column>
          <el-table-column prop="settingKey" :label="$t('shopSetting.settingKey')" align="center"></el-table-column>
          <el-table-column prop="settingValue" :label="$t('shopSetting.settingValue')" align="center"></el-table-column>
          <el-table-column :label="$t('common.operation')" align="center" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openEditShopSettingModel(scope.row)">{{ $t('common.edit') }}</el-button>
              <el-button size="mini" type="danger" @click="_openDeleteShopSettingModel(scope.row)">{{
                $t('common.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page.sync="shopSettingManageInfo.conditions.page"
          :page-size="shopSettingManageInfo.conditions.row" layout="total, prev, pager, next"
          :total="shopSettingManageInfo.total" style="margin-top:20px;"></el-pagination>
      </div>
    </el-card>

    <add-shop-setting ref="addShopSetting" @refresh="_queryShopSettingMethod"></add-shop-setting>
    <edit-shop-setting ref="editShopSetting" @refresh="_queryShopSettingMethod"></edit-shop-setting>
    <delete-shop-setting ref="deleteShopSetting" @refresh="_queryShopSettingMethod"></delete-shop-setting>
  </div>
</template>

<script>
import { getDict, getShopId } from '@/api/shop/shopApi'
import { queryShopSetting } from '@/api/goods/shopSettingApi'
import AddShopSetting from '@/components/goods/addShopSetting/addShopSetting'
import EditShopSetting from '@/components/goods/editShopSetting/editShopSetting'
import DeleteShopSetting from '@/components/goods/deleteShopSetting/deleteShopSetting'

export default {
  name: 'ShopSettingManage',
  components: {
    AddShopSetting,
    EditShopSetting,
    DeleteShopSetting
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      shopSettingManageInfo: {
        shopSettings: [],
        settingTypes: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          shopId: '',
          page: 1,
          row: 10,
          settingName: '',
          settingType: '',
          settingKey: '',
          settingValue: ''
        }
      }
    }
  },
  created() {
    this.shopSettingManageInfo.conditions.shopId = getShopId()
    this._listShopSettings(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    this.getSettingTypes()
    console.log(this.shopSettingManageInfo.records)
  },
  methods: {
    async getSettingTypes() {
      try {
        const { data } = await getDict('shop_setting_key', 'setting_type')
        this.shopSettingManageInfo.settingTypes = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listShopSettings(page, rows) {
      this.shopSettingManageInfo.conditions.page = page
      this.shopSettingManageInfo.conditions.row = rows

      try {
        const res = await queryShopSetting(this.shopSettingManageInfo.conditions)
        this.shopSettingManageInfo.total = res.total
        this.shopSettingManageInfo.records = res.records
        this.shopSettingManageInfo.shopSettings = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleCurrentChange(val) {
      this._listShopSettings(val, this.DEFAULT_ROWS)
    },
    _openAddShopSettingModal() {
      this.$refs.addShopSetting.open()
    },
    _openEditShopSettingModel(row) {
      this.$refs.editShopSetting.open(row)
    },
    _openDeleteShopSettingModel(row) {
      this.$refs.deleteShopSetting.open(row)
    },
    _queryShopSettingMethod() {
      this._listShopSettings(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetCommunitySettingMethod() {
      this.shopSettingManageInfo.conditions.settingType = ""
      this.shopSettingManageInfo.conditions.settingName = ""
      this.shopSettingManageInfo.conditions.settingKey = ""
      this._listShopSettings(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.ibox-title {
  border-color: #edf1f2;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  clear: both;
  padding: 15px 20px 20px 20px;
}
</style>